// 加购适配器

import { IBaseCartGoodsItem } from '@/api/types/cart';
import { IPrice } from '@/api/types/public';
import { BaseCartRequestData } from '@/app/[variants]/_lens-components/types';
import logger from '@/utils/client-logger';
import { env } from '@/utils/env';
import { genPrice } from '@/utils/price';
import { ProviderType, TrackingEvent } from '../types';

export function addToCartSuccessAdapter(
  data: {
    lensGoodsItem: IBaseCartGoodsItem;
    requestData: BaseCartRequestData;
    totalPrice: IPrice;
    ttqEventId: string;
    quantity?: number;
  },
  provider: ProviderType,
  eventId?: string,
): TrackingEvent | TrackingEvent[] | null {
  const { lensGoodsItem, requestData, totalPrice, ttqEventId, quantity = 1 } = data;
  const { product } = lensGoodsItem;

  const finalPrice = genPrice(product.price_info, requestData.currency).sell_price;
  const baseFinalPrice = genPrice(product.price_info, env.NEXT_PUBLIC_DEFAULT_CURRENCY).sell_price;
  const oPrice = genPrice(product.price_info, requestData.currency).price;

  logger.warn('addToCartSuccessAdapter====', data, provider);

  switch (provider) {
    case ProviderType.GA4:
      return [
        {
          commandType: 'event',
          eventName: 'add_to_cart',
          eventId,
          properties: {
            send_to: env.NEXT_PUBLIC_GA4_AD_ID1,
            value: totalPrice.sell_price,
            items: [
              {
                id: lensGoodsItem.product_id,
                item_id: product.shop_sku || '',
                google_business_vertical: 'retail',
              },
            ],
          },
        },
        {
          commandType: 'event',
          eventName: 'add_to_cart',
          eventId,
          properties: {
            currency: requestData.currency,
            value: finalPrice,
            items: [
              {
                item_id: product.shop_sku || '',
                item_name: product.short_name || '',
                discount: (
                  Number(oPrice.replace(/[^\d.]/g, '')) - Number(finalPrice.replace(/[^\d.]/g, ''))
                ).toFixed(2),
                item_category: requestData.option?.prescription_type || '',
                item_variant: product.color || '',
                price: finalPrice,
                quantity,
              },
            ],
          },
        },
      ];
    case ProviderType.FACEBOOK:
      logger.warn('addToCartSuccessAdapter====facebook', data, provider);
      return {
        eventName: 'AddToCart',
        eventId,
        properties: {
          content_type: 'product',
          content_ids: product.shop_sku,
          value: totalPrice.sell_price,
          currency: requestData.currency,
        },
      };
    case ProviderType.BING:
      return [
        {
          eventName: 'downloadbuttonclick',
          eventId,
          properties: {
            event_category: 'Cart',
            event_label: 'buttonclick',
            event_value: 5,
          },
        },
        {
          eventName: 'add_to_cart',
          eventId,
          properties: {},
        },
      ];
    case ProviderType.TIKTOK:
      return {
        eventName: 'AddToCart',
        eventId,
        properties: {
          quantity,
          content_type: 'product',
          content_id: product.shop_sku,
          event_id: eventId || ttqEventId, // 优先使用统一的 eventId
          currency: requestData.currency,
          server_report_data: {
            contents: [
              {
                content_id: product.shop_sku,
                content_type: 'product',
                content_name: product.short_name,
              },
            ],
            currency: requestData.currency,
            value: finalPrice,
          },
          value: finalPrice,
        },
      };
    case ProviderType.APPLOVIN:
      return {
        eventName: 'add_to_cart',
        eventId,
        properties: {
          currency: env.NEXT_PUBLIC_DEFAULT_CURRENCY,
          items: [
            {
              item_id: product.spu,
              item_variant_id: product.shop_sku,
              image_url:
                product.image.celebrity[0] || product.image.material[0] || product.image.product[0],
              item_name: product.short_name,
              price: parseFloat(baseFinalPrice),
              quantity,
            },
          ],
          value: parseFloat(baseFinalPrice),
        },
      };
    case ProviderType.TWITTER:
      return [
        {
          eventName: 'tw-of32e-of32l',
          eventId,
          properties: {},
        },
        {
          eventName: 'tw-of2hc-of31x',
          eventId,
          properties: {},
        },
      ];
    case ProviderType.SNAPCHAT:
      return {
        eventName: 'ADD_CART',
        eventId,
        properties: {
          price: parseFloat(totalPrice.sell_price),
          currency: requestData.currency,
          item_ids: [product.shop_sku],
          item_category: 'eyewear',
          number_items: quantity,
        },
      };
    case ProviderType.SNAPCHAT_CONVERSION:
      return {
        eventName: 'ADD_CART',
        eventId,
        properties: {
          currency: requestData.currency,
          contents: [
            {
              id: product.shop_sku,
              quantity,
              item_price: parseFloat(totalPrice.sell_price),
            },
          ],
        },
      };
    case ProviderType.RTB_HOUSE:
      return {
        eventName: 'basketadd',
        eventId,
        properties: {
          offerId: product.shop_sku,
        },
      };
    default:
      return null;
  }
}
